var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('fullCalendar',{ref:"calendar",attrs:{"options":_vm.calendarOptions}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }